import { memo } from "react";
import { Label } from "react-aria-components";
import { CheckboxGroup } from "@/components/base/checkbox-groups/checkbox-groups";

type LocalList = {
  id: string;
  name: string;
  creatorCount: number;
  description?: string | null;
  createdAt?: string;
  isNew?: boolean;
  isPending?: boolean;
};

// Memoized component to prevent re-renders while typing in search
export const ListsTable = memo(
  ({
    allLists,
    selected,
    onSelectionChange,
    formatDate,
  }: {
    allLists: LocalList[];
    selected: string[];
    onSelectionChange: (selected: string[]) => void;
    formatDate: (dateString: string) => string;
  }) => {
    return (
      <div className="relative flex-1 min-h-0 max-h-[30rem] h-full">
        <div className="overflow-y-auto h-full">
          {allLists.length > 0 ? (
            <CheckboxGroup
              value={selected}
              onChange={onSelectionChange}
              className="gap-2"
              items={allLists.map((list) => ({
                value: list.id,
                title: list.name,
                secondaryTitle: list.createdAt ? formatDate(list.createdAt) : "",
                description: list.description ?? undefined,
              }))}
              render={(item) => (
                <div className="w-full flex items-center">
                  <div className="flex flex-row items-center w-full justify-between">
                    <Label className="flex flex-col gap-1 flex-1">
                      <span className="text-secondary text-sm font-medium">{item.title}</span>
                      {item.description && <span className="text-tertiary text-xs">{item.description}</span>}
                    </Label>
                    <Label className="flex gap-1">
                      <span className="text-tertiary text-sm">{item.secondaryTitle}</span>
                    </Label>
                  </div>
                </div>
              )}
            />
          ) : (
            <div className="flex items-center justify-center py-8 text-tertiary text-sm">
              No lists match your search
            </div>
          )}
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-white to-transparent pointer-events-none" />
      </div>
    );
  },
);

ListsTable.displayName = "ListsTable";
